<div #viewer id="imageViewer" @simpleFadeAnimation>
  <div class="image-buttons-wrapper">
    <button #closeButton type="button" class="gclose gbtn" aria-label="Close" (click)="close()">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" xml:space="preserve">
        <path d="M505.943,6.058c-8.077-8.077-21.172-8.077-29.249,0L6.058,476.693c-8.077,8.077-8.077,21.172,0,29.249C10.096,509.982,15.39,512,20.683,512c5.293,0,10.586-2.019,14.625-6.059L505.943,35.306C514.019,27.23,514.019,14.135,505.943,6.058z"/>
        <path d="M505.942,476.694L35.306,6.059c-8.076-8.077-21.172-8.077-29.248,0c-8.077,8.076-8.077,21.171,0,29.248l470.636,470.636c4.038,4.039,9.332,6.058,14.625,6.058c5.293,0,10.587-2.019,14.624-6.057C514.018,497.866,514.018,484.771,505.942,476.694z"/>
      </svg>
    </button>
    <div #buttons class="buttons-wrapper animate__animated animate__fadeIn animate__delay-1s" #buttonsWrapper [ngStyle]="position ? {top: position.top + 10 + 'px', left: position.right - 10 - buttonsWrapper.clientWidth + 'px'} : {}">
      <app-centrui-button-icon [buttonStyle]="'image-button references'" *ngIf="referenceable.image_references && referenceable.image_references!.length > 0" [icon]="'new/document-attachment.svg'" [pxTooltip]="'This Attachment has ' + referenceable.image_references!.length + ' reference' + (referenceable.image_references!.length > 1 ? 's' : '') + ' to view'" pxTooltipPlacement="bottom" (clicked)="toggleReferences()"></app-centrui-button-icon>
      <app-centrui-button-icon [buttonStyle]="'image-button context'" *ngIf="referenceable.context" [icon]="'new/menu-01.svg'" [pxTooltip]="'See additional context'" pxTooltipPlacement="bottom" pxTooltipClass="image-viewer-context-hint text-center" (clicked)="toggleContext()"></app-centrui-button-icon>
    </div>
  </div>
  <div class="panel" *ngIf="showContext || showReferences" @simpleFadeAnimation>
    <div class="panel-header">
      <span>{{ referenceable.name }}</span>
      <app-centrui-button-icon [icon]="'new/cancel-01.svg'" [buttonStyle]="'medium white-fill '" (clicked)="hidePanel()"></app-centrui-button-icon>
    </div>
    <div class="panel-content" [ngStyle]="showReferences ? {border: 'none'} : {}">
      <ng-container *ngIf="showContext">
        <h5>Context</h5>
        <div class="context" [innerHTML]="referenceable.context! | safe"></div>
      </ng-container>
      <ng-container *ngIf="showReferences">
        <div class="reference" (click)="viewReference(reference)" *ngFor="let reference of referenceable.image_references; let i = index">
          <div class="reference-header">
            <span>Reference {{i+1}}</span>
            <div class="annotations-count">
              {{reference.annotations.length}}
            </div>
          </div>
          <div class="reference-body">
            {{reference.attachment.name}}
          </div>
        </div>
      </ng-container>
    </div>
  </div>
